import { createComponent, createHook } from "reakit-system";
import type { ComponentPropsWithRef } from "react";
import type { CheckerIconOptions } from "./useCheckerIcon";
import { useCheckerIcon } from "./useCheckerIcon";
import type { BoxOptions } from "../../Box/Box";
import { useBox } from "../../Box/Box";
import { useStyles } from "../useStyles";

type CheckablesWrapperOptions = CheckerIconOptions & BoxOptions;

const useCheckablesLabel = createHook<CheckablesWrapperOptions, ComponentPropsWithRef<"label">>({
  name: "useCheckablesWrapper",
  compose: [useBox, useStyles, useCheckerIcon],
  keys: ["kind", "disabled"],
  useOptions(options) {
    return {
      display: "flex",
      maxWidth: 1,
      ...options,
    };
  },
});

export const CheckablesLabel = createComponent<"label", CheckablesWrapperOptions>({
  useHook: useCheckablesLabel,
  as: "label",
});
